'use client';

import { NAME_MAX } from '@peach/types/tutors/identity-limits.js';
import { AmbassadorMark } from '@/components/AmbassadorMark';
import { EditableText } from './EditableText';
import { FitName } from './FitName';

/** The owner's masthead: the name itself is the field. */
export function EditableName({
  name,
  ambassador = false,
  onSave,
}: {
  name: string;
  ambassador?: boolean;
  /** Resolves to an error to show, or null once the name is saved. */
  onSave: (next: string) => Promise<string | null>;
}) {
  return (
    <FitName name={name}>
      <EditableText
        value={name}
        limit={NAME_MAX}
        label="Name"
        required="A page needs a name"
        onSave={onSave}
      />
      {ambassador && <AmbassadorMark />}
    </FitName>
  );
}
